import { useItems } from "@adamlip/okeoke.client"
import ListItemShell from "views/Order/ItemList/ListItemShell"

export default function GroupMember({
  member,
  sizeGroupUUID,
  addMember,
  selectedCount,
}) {
  const { sizes } = useItems()

  const onAdd = (item) => {
    addMember({ ...item, sizeGroupUUID, price: member.price })
  }

  return (
    <div className="relative w-full max-w-[400px]">
      {selectedCount != null && selectedCount > 0 && (
        <div className="bg-[var(--button-bg-color)] text-[var(--button-text-color)] w-[24px] h-[24px] flex justify-center items-center rounded-full absolute top-[-8px] right-[-8px] z-10 text-sm">
          {selectedCount}
        </div>
      )}
      <ListItemShell
        itemUUID={sizes?.[member.uuid]?.itemUUID}
        isLoading={sizes?.[member.uuid]?.itemUUID == null}
        menuItemParams={{
          onAdd,
          defaultCount: member.defaultCount,
          minSelect: member.minSelect,
          maxSelect: member.maxSelect,
          selectedSizeUUID: member.uuid,
          price: member.price,
          selected: selectedCount > 0,
          onScreenOff: true,
        }}
      />
    </div>
  )
}
